import * as React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { connect } from 'react-redux';
import { AppState } from '../../model/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { loadingOverlay, broadcastMessage } from '../../model/overlay/actions';
import { BroadcastType } from '../../model/overlay/types';
import { NavigationTabProps } from '../../model/navigation/types';
import { withTranslation } from 'react-i18next';



// ----------------- State & Props -----------------  //

interface State 
{

};

interface StateProps
{

};

interface DispatchProps
{
    loading: ()=>void;
    doneLoading: ()=>void;
    broadcast: (msg: string, type?: BroadcastType) => void;
};

type Props = NavigationTabProps & StateProps & DispatchProps;

// -------------------- Class --------------------  //

class SubmitSupportTicket extends React.Component<Props, State> 
{
    // ============================================ //
    //               Member Variables               //
    // ============================================ //

    translation: any;

    // ============================================ //
    //               Routine Functions              //
    // ============================================ //

    constructor(props: any)
    {
        super(props);

        // Init State
        this.state = {

        };

        // Setup Member Functions
    }

    render()
    {
        const { t } = this.props;

        return (<>
            <Box sx={{ maxWidth: 936, margin: 'auto', overflow: 'hidden' }}>
                <Typography sx={{mb: "30px", ml: 1, fontSize: 18, fontWeight: 5}}>
                    {t('support.submitSupportTicket')}
                </Typography>
            </Box>
            <Paper sx={{ maxWidth: 936, margin: 'auto', height: 'auto', overflow: 'hidden' }}>
                <Typography sx={{m: 5, mb: 1, verticalAlign: 'center', fontSize: 18}}>
                    ViewBase Care
                </Typography>
                <Typography sx={{m: 5, mt: 1, mb: 1, verticalAlign: 'center'}}>
                    <a href="https://viewbase.se/losning/vart-servicekoncept-viewbase-care/">
                        {t('support.aboutViewbaseCare')}
                    </a>
                </Typography>
                <Typography sx={{m: 5, mt: 1, verticalAlign: 'center'}}>
                    <a href="https://cloudpro.atlassian.net/servicedesk/customer/portal/12/user/login?destination=portal%2F12">
                        {t('support.toSupportPortal')}
                    </a>
                </Typography>
            </Paper>
        </>);
    }

    // ============================================ //
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState, props: NavigationTabProps): StateProps => ({

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{},{},any>, props: NavigationTabProps): DispatchProps => ({
    loading: ()=>dispatch(loadingOverlay(true)),
    doneLoading: ()=>dispatch(loadingOverlay(false)),
    broadcast: (msg, type?)=>dispatch(broadcastMessage(msg, type))
});

export default withStyles(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SubmitSupportTicket)));

// ------------------------------------------  //